import { AdsCampaignArea } from "./ads-campaign-area";
import { AdsCampaignAsset } from "./ads-campaign-asset";
import { AdsOrganization } from "./ads-organization";
import { AdsUser } from "./ads-user";
import { Organization } from "./organization";

export class AdsCampaign {
    id!: number;
    ads_organization: AdsOrganization = new AdsOrganization();
    areas: AdsCampaignArea[] = [];
    created_at!: Date;
    created_by!: AdsUser;
    updated_at!: Date;
    updated_by!: AdsUser;
    name!: string;
    type!: string;
    status!: string;
    organization: Organization = new Organization();
    notes!: string;
    assets: AdsCampaignAsset[] = [];
    start_date!: string;
    end_date!: string;
}
